"use client";

import gsap from "gsap";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { Swiper, SwiperSlide } from "swiper/react";
//
import { Button } from "@/components";
import { getImageURL, useSwiperSliderOptions } from "@/lib";

function decodeHTMLEntities(str) {
    if (!str) return "";
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
}

export const HomePageAbout = ({ data = {}, slug = "about-us" }) => {
    const { heading, description, image } = data;

    return (
        <section className="home_aboutus" id={slug}>
            <div className="custom-container">
                <div className="d-flex home_aboutus_row">
                    <div className="home_aboutus_left">
                        <div className="fs-16 home_aboutus_content">
                            <h2
                                className="fs-48"
                                dangerouslySetInnerHTML={{ __html: heading }}
                            />
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        </div>
                    </div>
                    <div className="home_aboutus_right">
                        <div className="home_aboutus_img">
                            <img
                                src={getImageURL(image?.src)}
                                alt={image?.alt || ""}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
